import Panel from "../Panel/Panel";
import "../../assets/css/sensitive-area.css";
import useQueryChildData from "../Hooks/useQueryChildData";
import { useContext, useState } from "react";
import { Modal } from 'slide-ui';
import StateContext from "../../state/stateContext";
import LearnMoreButton from "../ProfileButtons/LearnMoreButton";
import SensitivityModal from "../ProfileSection/SensitivityModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import NonBreakingSpace from "../Expando/NonBreakingSpace";

export function SensitiveArea(props) {
    const [showModal, setShowModal] = useState(false);
    const context = useContext(StateContext);
    const childInfo = useQueryChildData(context);
    const childData = childInfo.data;
    const handleModal = (e) => {
      setShowModal(!showModal)
      //prevent the "#" from showing up in the url.
      e.preventDefault();
    }

  if (!childData?.christianWitnessSensitivityCode || childData?.christianWitnessSensitivityCode == '3' || !childData) {
    return null;
  }

  return (
    <div>
    <div className="alert alert-danger sensitive"><FontAwesomeIcon icon={solid("circle-exclamation")} /><NonBreakingSpace /><NonBreakingSpace />Sensitive Area</div>
    <Panel classList="sensitive-panel">
      <h3 className="">What Does this Mean?</h3>
      <p className="sensitive-paragraph">
      World Vision is privileged to offer sponsorship in many communities where the majority of the families we serve are not Christian. When working in these communities, we not only abide by local laws and customs but also strive to show respect and honor to those of different faiths.
      </p>
      <div className="sensitive-modal">
        <a href="#" onClick={(e) => handleModal(e)}>Learn More</a>
        <Modal 
          toggle={() => setShowModal(false)}
          isOpen={showModal}
          hasTitle={false}
          hasFooter={false}
          sendClick={() => {}}
        >
          <SensitivityModal
            data={childData}
          />
        </Modal> 
      </div>
    </Panel>
    </div>
  );
}

export default SensitiveArea;